import CometMarquee from 'comet-marquee';
import 'comet-marquee/dist/comet-marquee.css';

const trustedMarqueeElsArr = document.querySelectorAll(
    '.trusted-sec__marquee'
);

if (trustedMarqueeElsArr.length) {
  trustedMarqueeElsArr.forEach((marqueeEl, idx) => {
    const marquee = new CometMarquee(marqueeEl, {
      speed: 50,
      adaptivePause: true,
      reverse: idx % 2 === 1,
      pauseOnInvisible: true,
      initialShift: true,
    });
  });
}
